import { FlightQuoteDetails } from "@/types/flight-quote-details"

import { baseApi } from "./base-api"

export interface GetFlightQuoteDetailsArgs {
  ref: string // e.g., "fq-A62LopFe"
  shareCode?: string
}

export const flightQuotesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFlightQuoteDetails: builder.query<
      FlightQuoteDetails,
      GetFlightQuoteDetailsArgs
    >({
      query: ({ ref, shareCode }) => ({
        url: `/api/flights/quotes/${ref}`,
        params: shareCode ? { share_code: shareCode } : undefined,
      }),
      transformResponse: (response: { data: FlightQuoteDetails }) =>
        response.data,
      providesTags: (result, _error, { ref }) =>
        result ? [{ type: "FlightQuoteDetails", id: ref }] : [],
    }),
  }),
})

export const {
  useGetFlightQuoteDetailsQuery,
  useLazyGetFlightQuoteDetailsQuery,
} = flightQuotesApi
